import * as React from "react";
import { BarSeries } from "./BarSeries";
import { LineSeries } from "./LineSeries";
import { StraightLine } from "./StraightLine";
/**
 * The MACD turns two trend-following indicators, moving averages, into a momentum oscillator by subtracting the longer moving average from the shorter one.
 */
export class MACDSeries extends React.Component {
    constructor() {
        super(...arguments);
        this.yAccessorForDivergenceBase = (xScale, yScale) => {
            return yScale(0);
        };
        this.yAccessorForDivergence = (d) => {
            const { yAccessor } = this.props;
            const dataItem = yAccessor(d);
            if (dataItem !== undefined) {
                return dataItem.divergence;
            }
            return undefined;
        };
        this.yAccessorForSignal = (d) => {
            const { yAccessor } = this.props;
            const dataItem = yAccessor(d);
            if (dataItem !== undefined) {
                return dataItem.signal;
            }
            return undefined;
        };
        this.yAccessorForMACD = (d) => {
            const { yAccessor } = this.props;
            const dataItem = yAccessor(d);
            if (dataItem !== undefined) {
                return dataItem.macd;
            }
            return undefined;
        };
    }
    render() {
        const { className, clip, fillStyle = MACDSeries.defaultProps.fillStyle, strokeStyle = MACDSeries.defaultProps.strokeStyle, widthRatio, width, } = this.props;
        return (React.createElement("g", { className: className },
            React.createElement(BarSeries, { baseAt: this.yAccessorForDivergenceBase, width: width, widthRatio: widthRatio, fillStyle: fillStyle.divergence, clip: clip, yAccessor: this.yAccessorForDivergence }),
            React.createElement(LineSeries, { yAccessor: this.yAccessorForMACD, strokeStyle: strokeStyle.macd }),
            React.createElement(LineSeries, { yAccessor: this.yAccessorForSignal, strokeStyle: strokeStyle.signal }),
            React.createElement(StraightLine, { strokeStyle: strokeStyle.zero, yValue: 0 })));
    }
}
MACDSeries.defaultProps = {
    className: "react-financial-charts-macd-series",
    clip: true,
    fillStyle: {
        divergence: "rgba(70, 130, 180, 0.6)",
    },
    strokeStyle: {
        macd: "#0093FF",
        signal: "#D84315",
        zero: "rgba(0, 0, 0, 0.3)",
    },
    widthRatio: 0.5,
    width: BarSeries.defaultProps.width,
};
//# sourceMappingURL=MACDSeries.js.map